import * as React from 'react';
import { Box, BoxProps } from '@material-ui/core/';
import { useStyles } from './BlockWrapper.styles';

type BlockWrapperProps = BoxProps & {
  hasWrap?: boolean;
}

const BlockWrapper: React.FC<React.PropsWithChildren<{} & BlockWrapperProps>> = ({children, hasWrap=true, ...props}) => {
  const classes = useStyles();

  return (
    <Box {...props}>
      <Box className={hasWrap ? classes.wrapper : ''}>{children}</Box>
    </Box>
  )
}

export default BlockWrapper;